










































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { UserDTO, UserStatus } from '@/interfaces/Usuarios.interface'
import { RolDTO } from '@/interfaces/UsuariosRol.interface'
import { HTTP } from '@/plugins/axios'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'

@Component
export default class DialogNewUsuario extends Vue {
  @Prop() private msg!: string
  @Prop({ type: Object })
  private info!: UserDTO
  @Prop({ type: Boolean })
  private update!: boolean
  @Prop({ type: String })
  private action!: string
  @Prop({ type: Array })
  private rol!: RolDTO[]

  private name: string = 'DialogNewUsuario'

  private mModel: UserDTO = {
    name: '',
    email: '',
    password: '',
    status: false
  }

  private bModel: UserDTO = {
    name: '',
    email: '',
    password: '',
    status: false
  }

  private status: UserStatus[]  = [
    {
      text: 'Bloqueado',
      value: true
    },
    {
      text: 'Desbloqueado',
      value: false
    }
  ]

  private dialog: boolean = false
  private mAction: string = 'new'
  private titleNew: string = 'Agregar Usuario'
  private titleMod: string = 'Modificar Usuario'

  private textMSG: TextMSGDTO = {
    success: {
      text: 'Nuevo Usuario:',
      color: 'success'
    },
    update: {
      text: 'Modificado Usuario:',
      color: 'info'
    },
    fail: {
      text: 'Error al guardar:',
      color: 'error'
    },
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    if (typeof this.info === 'object') this.mModel = this.info
    if (typeof this.action === 'object') this.mAction = this.action
  }

  @Watch('info')
  private watchInfo (v: UserDTO) {
    if (typeof v === 'object') {
      this.mModel = Object.assign({}, v)
      this.mAction = 'edit'
      this.dialog = true
    }
  }

  @Watch('dialog')
  private watchDialog (v: boolean) {
    console.log('watchDialog :: ', v)
    if (!v) {
      this.mModel = Object.assign({}, this.bModel)
      this.mAction = 'new'
      this.$emit('update:action', this.mAction)
    }
  }

  @Emit('update')
  private emitUpdate (v: boolean) {
    console.log('emitUpdate :: ', v)
    this.$emit('update:update', v)
  }

  private CreateUsuario (item: UserDTO) {
    console.log('CreateUsuario :: ', item)
    HTTP.post('user/', item)
      .then((response) => {
        console.log('CreateUsuario :: response :: ', response.data)
        this.emitUpdate(response.data.success)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.success.text + ' ' + item.name,
          color: this.textMSG.success.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('CreateUsuario :: catch :: ', e.response.data)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private UpdateUsuario (item: UserDTO) {
    console.log('UpdateUsuario :: ', item)
    HTTP.put('user/' + item.id, item)
      .then((response) => {
        console.log('UpdateUsuario :: response :: ', response.data)
        this.emitUpdate(response.data.success)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.update.text + ' ' + item.name,
          color: this.textMSG.update.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('UpdateUsuario :: catch :: ', e.response.data)
        this.dialog = false
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }
}
